<template>
  <section class="mb-5">
    <h1>{{ $t("profile") }}</h1>

    <div class="row align-items-center justify-content-center mb-4">
      <div class="col-6 offset-md-0 col-md-2 mb-3 mb-md-0">
        <img
          v-if="user.photoURL !== null"
          :src="user.photoURL"
          alt=""
          class="rounded w-100"
        />

        <img
          v-else
          alt=""
          class="rounded w-100"
          src="../assets/img/noimage.jpg"
        />
      </div>

      <div class="col-12 col-md-10 text-center text-md-start">
        <h2 class="mb-2">{{ user.displayName }}</h2>

        <p v-if="user.title !== null">{{ user.title }}</p>

        <p>{{ user.email }}</p>
      </div>
    </div>

    <div>
      <router-link
        :to="{ name: 'settings' }"
        class="btn btn-light d-block d-md-inline-block"
      >
        {{ $t("settings") }}
      </router-link>
      <router-link
        :to="{ name: 'membership' }"
        class="btn btn-light d-block d-md-inline-block mt-3 mt-md-0 ms-md-3"
      >
        {{ $t("membership") }}
      </router-link>
    </div>
  </section>

  <section class="mb-5">
    <h2>{{ $t("useMembership") }}</h2>
    <a
      class="btn btn-secondary d-block d-md-inline-block"
      href="https://numbersofsuccess.page.link/download"
      target="_blank"
    >
      {{ $t("downloadApp") }}
    </a>
  </section>

  <section>
    <h2>{{ $t("extendMembership") }}</h2>

    <p class="mb-5">
      <router-link
        :to="{ name: 'membership.extend.360' }"
        class="btn btn-secondary d-block d-md-inline-block"
      >
        {{ $t("extendMembership360") }}
      </router-link>
    </p>

    <i18n-t keypath="homePageAffiliate" tag="p">
      <span class="text-secondary">{{ $tc("days", 90) }}</span>
      <span
        class="text-secondary"
        id="affiliateEmail"
        @click.prevent="selectAffilaiteEmail"
        >{{ user.email }}</span
      >
    </i18n-t>

    <div
      v-if="$route.params.feedback === 'true'"
      id="feedback"
      class="border border-secondary rounded p-3"
    >
      <h4 class="mb-2">{{ $t("feedback") }}</h4>
      <i18n-t keypath="homePageFeedback" tag="p">
        <span class="text-secondary">{{ $tc("days", 90) }}</span>
        <a
          href="mailto:feedback@numbersofsuccess.com?subject=Feedback"
          class="text-secondary text-decoration-none"
        >
          feedback@numbersofsuccess.com</a
        >
      </i18n-t>
    </div>

    <i18n-t v-else keypath="homePageFeedback" tag="p">
      <span class="text-secondary">{{ $tc("days", 90) }}</span>
      <a
        href="mailto:feedback@numbersofsuccess.com?subject=Feedback"
        class="text-secondary text-decoration-none"
      >
        feedback@numbersofsuccess.com</a
      >
    </i18n-t>
  </section>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      emailCopiedTooltip: null,
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },
  },
  methods: {
    selectAffilaiteEmail() {
      if (document.selection) {
        const range = document.body.createTextRange();
        range.moveToElementText(document.getElementById("affiliateEmail"));
        range.select();
      } else if (window.getSelection) {
        const range = document.createRange();
        range.selectNode(document.getElementById("affiliateEmail"));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
  },
  mounted() {
    if (this.$route.params.feedback === "true") {
      document.querySelector("#feedback").scrollIntoView();
    }
  },
};
</script>

<style scoped></style>
